<script>
import Layout from "../../layouts/main.vue";
import appConfig from "@/app.config";
import PaymentPlane from "../../views/payment/payment-component-new.vue"

export default {
  page: {
    title: "Page de paiement",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout ,PaymentPlane
  }
}
  </script>


<template>
  <Layout>
    <PaymentPlane></PaymentPlane>
  </Layout>
</template>